import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import HeroSlideshow from '../components/HeroSlideshow';
import InstagramFeed from '../components/InstagramFeed';
import instagramFeed from '../data/instagram.json';

// ── Icons ────────────────────────────────────────────────────────────────────
const CalendarIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
  </svg>
);
const UserIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
  </svg>
);
const BookIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
  </svg>
);
const PhoneIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
  </svg>
);
const ForkIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M6 3v7a2 2 0 002 2h0a2 2 0 002-2V3M8 3v18M18 3c-2 1.5-3 4-3 7h3v11" />
  </svg>
);
const SparklesIcon = () => (
  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
  </svg>
);
const GlobeIcon = () => (
  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
  </svg>
);
const ArrowRightIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true" strokeWidth={2.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M13 7l5 5m0 0l-5 5m5-5H6" />
  </svg>
);
const InstagramIcon = () => (
  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
  </svg>
);

const HomePage = () => {
  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (mediaQuery.matches) document.documentElement.style.setProperty('--animation-duration', '0.01ms');
    const handler = (e) => document.documentElement.style.setProperty('--animation-duration', e.matches ? '0.01ms' : '');
    mediaQuery.addEventListener('change', handler);
    return () => mediaQuery.removeEventListener('change', handler);
  }, []);

  const schoolData = {
    principal: 'James Konstantinakos',
    socialLinks: {
      instagram: 'https://www.instagram.com/ps96act/',
      facebook: 'http://www.facebook.com/PS96Lions',
    },
    quickLinks: {
      parentPortal: 'https://mystudent.nyc/',
      nycdoe: 'https://www.schools.nyc.gov/',
      calendar: '/calendar',
      faculty: '/directory/faculty',
      lunchMenu: 'https://www.schools.nyc.gov/school-life/school-meals/menus/school-lunch-meals?value=s8',
    },
  };

  // Hero slideshow. 'cover' photos fill the banner; lower-resolution or portrait photos use
  // 'contain' so they are shown whole instead of being stretched.
  const hero = (name) => ({ src: `/assets/images/hero/${name}.jpg`, thumb: `/assets/images/hero/${name}-thumb.jpg` });
  const slides = [
    { ...hero('hero-students-awards'), pos: 'center 30%', label: 'Students with awards', alt: 'Five smiling PS 96 students proudly hold award certificates and medals, standing beside a smiling teacher in the school gym' },
    { ...hero('hero-prek-art-project'), fit: 'contain', label: 'Pre-K art project', alt: 'A young student in a black hoodie glues colorful dots onto a paper art project on a red tray at a classroom table' },
    { ...hero('hero-stage-performance'), pos: 'center 38%', label: 'Stage performance', alt: 'A student in a lavender dress sings into a microphone on a school stage decorated with paper flowers and butterflies while classmates sit nearby' },
    { ...hero('hero-staff-landforms-map'), fit: 'contain', label: 'Teacher and administrator', alt: 'A smiling PS 96 teacher in a floral dress and a smiling administrator in a gray blazer stand in front of a world map of landforms in a classroom' },
    { ...hero('hero-museum-trip'), pos: 'center 60%', label: 'Museum class trip', alt: 'A large PS 96 class sits together in front of towering dinosaur skeletons on a museum trip, smiling for the camera' },
    { ...hero('hero-garden-composting'), fit: 'contain', label: 'School garden', alt: 'PS 96 students in school shirts and work gloves tend the school garden compost bin, with an orange bucket of plant cuttings and a bridge in the background' },
    { ...hero('hero-teacher-students'), pos: 'center 40%', label: 'Teacher with students', alt: 'A teacher leans over a table of students working on a hands-on craft project in a classroom' },
    { ...hero('hero-groundbreaking'), fit: 'contain', label: 'Groundbreaking ceremony', alt: 'School and city officials and construction workers in hard hats and orange safety vests pose with ceremonial golden shovels at a groundbreaking' },
    { ...hero('hero-wellness-event'), pos: 'center 55%', label: 'Student wellness event', alt: 'PS 96 students in navy school sweatshirts and other girls decorate crafts at a long red table during a school wellness event' },
    { ...hero('hero-prek-art-glue'), fit: 'contain', label: 'Pre-K crafts', alt: 'A young student in a pink sweatshirt works on a crayon and glue art project at a classroom table' },
  ];

  const upcomingEvents = [
    { month: 'Nov', day: '5', weekday: 'Thursday, Nov 5', time: '11:30 AM dismissal', title: 'Parent-Teacher Conferences — Half Day', href: '/calendar' },
    { month: 'Nov', day: '6', weekday: 'Friday, Nov 6', time: '9:00 – 10:00 AM', title: 'Fall Show Performance', href: '/calendar' },
    { month: 'Nov', day: '10', weekday: 'Every Tuesday', time: '2:30 – 3:00 PM', title: 'Food Pantry', href: '/food-pantry' },
    { month: 'Nov', day: '13', weekday: 'Friday, Nov 13', time: '8:30 AM', title: 'High School Fair', href: '/calendar' },
    { month: 'Nov', day: '19', weekday: 'Thursday, Nov 19', time: '2:30 PM', title: 'Parent Association Meeting', href: '/calendar' },
    { month: 'Nov', day: '24', weekday: 'Tuesday, Nov 24', time: '2:30 PM', title: 'Fall Festival — Food, Games, Prizes & More', href: '/announcements' },
    { month: 'Nov', day: '30', weekday: 'Mon, Nov 30 – Fri, Dec 4', title: 'Scholastic Book Fair', href: '/calendar' },
  ];

  const announcements = [
    '🦁  Welcome to PS 96 — Lanzetta School of the Arts, Collaboration & Technology',
    '🎬  Family Movie Night — Friday, Oct 23 at 3:00 PM · $5 per family (cash only)',
    '🏦  ClassBank School Store — Earn money and learn financial skills!',
    '⭐  Spring Enrollment Now Open — Apply for 3K, Pre-K & Kindergarten!',
    '📅  Spring Book Fair Coming Soon — Check the Calendar for Dates',
    '🎨  Arts & Technology Showcase — Stay tuned for more info',
    '🏆  Proud school of East Harlem, NYC — Go Lions!',
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <main id="main-content">

        {/* ── HERO ─────────────────────────────────────────────────────────── */}
        <section className="relative flex h-[100svh] min-h-[560px] w-full flex-col overflow-hidden bg-[#00213a]">
          {/* Photo slideshow — students, staff, and school events. */}
          <div className="relative min-h-0 flex-1">
            <HeroSlideshow slides={slides} label="Photos of PS 96 students, staff, and events" />
          </div>

          {/* Lower-third band — the hero copy sits on a slim, fully opaque navy
              strip below the photos, so the photos stay unobstructed and every
              line of text has a solid surface behind it. */}
          <div className="relative z-10 w-full border-t-2 border-[#fdbb2e] bg-[#00213a]">
            <div className="mx-auto flex max-w-[1400px] flex-col gap-3 px-6 py-3.5 md:px-10 md:py-4 lg:flex-row lg:items-center lg:justify-between lg:gap-8">
              <div className="min-w-0">
                <p className="sr-only">East Harlem, NYC</p>
                <h1 className="text-xl md:text-2xl lg:text-3xl font-extrabold leading-tight text-white">
                  Where{' '}
                  <span className="text-[#fdbb2e]">Creativity</span>{' '}
                  <span className="whitespace-nowrap">Meets Excellence</span>
                </h1>
                {/* The band shows only the school name; the rest of the intro
                    sentence stays in the accessibility tree. */}
                <p className="mt-0.5 text-xs md:text-sm font-semibold text-[#fdbb2e]">
                  Joseph C. Lanzetta School of the Arts, Collaboration, &amp; Technology
                  <span className="sr-only"> — empowering the next generation of innovators and artists.</span>
                </p>
              </div>

              <div className="grid grid-cols-2 gap-2 sm:flex sm:items-center sm:gap-3 lg:shrink-0">
                <a href="#visit" className="group inline-flex items-center justify-center gap-2 rounded-full bg-[#fdbb2e] hover:bg-[#ffd04e] px-3 py-2.5 text-xs font-black uppercase text-center tracking-[0.06em] sm:px-4 sm:tracking-[0.14em] text-[#00213a] transition-colors duration-200">
                  <span>Schedule a Tour</span>
                  <span className="hidden sm:inline-flex"><ArrowRightIcon /></span>
                </a>
                <a href="#about" className="inline-flex items-center justify-center gap-2 rounded-full border-2 border-white/50 hover:border-white px-3 py-2 text-xs font-bold uppercase text-center tracking-[0.06em] sm:px-4 sm:tracking-[0.14em] text-white transition-colors duration-200">
                  <span>Our Story</span>
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* ── QUICK LINKS ──────────────────────────────────────────────────── */}
        <section className="relative pt-10 z-20">
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="bg-white rounded-3xl shadow-2xl p-6 sm:p-8 border border-gray-200">
              <div className="flex flex-wrap gap-3 justify-center">
                {[
                  { icon: <CalendarIcon />, label: 'Calendar', href: schoolData.quickLinks.calendar },
                  { icon: <UserIcon />, label: 'Parent Portal', href: schoolData.quickLinks.parentPortal, external: true },
                  { icon: <BookIcon />, label: 'Staff Directory', href: schoolData.quickLinks.faculty },
                  { icon: <PhoneIcon />, label: 'Contact Us', href: '#contact' },
                  { icon: <GlobeIcon />, label: 'NYC DOE', href: schoolData.quickLinks.nycdoe, external: true },
                  { icon: <ForkIcon />, label: 'Lunch Menu', href: schoolData.quickLinks.lunchMenu, external: true },
                ].map((link, idx) => (
                  <a
                    key={idx}
                    href={link.href}
                    target={link.external ? '_blank' : undefined}
                    rel={link.external ? 'noopener noreferrer' : undefined}
                    className="inline-flex items-center gap-2 px-5 py-3 bg-gray-100 hover:bg-[#00213a] text-gray-900 hover:text-white rounded-full font-semibold text-sm transition-all duration-200 border border-gray-300 hover:border-[#00213a] hover:shadow-lg"
                  >
                    {link.icon}{link.label}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* ── ANNOUNCEMENT TICKER ──────────────────────────────────────────── */}
        <section className="mt-10 overflow-hidden" aria-label="School announcements">
          <div className="bg-[#fdbb2e] border-y-2 border-[#e8a800] flex items-stretch">
            <div className="flex-shrink-0 bg-[#00213a] text-white text-xs font-black uppercase tracking-widest px-6 flex items-center z-10">
              NEWS
            </div>
            <div className="overflow-hidden flex-1 py-3">
              <div
                className="flex whitespace-nowrap"
                style={{ animation: 'marquee 38s linear infinite', width: 'max-content' }}
              >
                {[...announcements, ...announcements].map((a, i) => (
                  <span key={i} className="inline-block mx-10 text-sm font-black text-[#00213a]">
                    {a} <span className="mx-4 text-[#00213a]/30" aria-hidden="true">◆</span>
                  </span>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* ── QUICK INFO CARDS ─────────────────────────────────────────────── */}
        {/* Bold colored info cards inspired by PS 145's program/admissions overlays */}
        <section className="py-16 bg-white" aria-labelledby="quick-info-heading">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 id="quick-info-heading" className="sr-only">Get Started at PS 96</h2>
            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">

              {/* Admissions */}
              <a href="/early-childhood" className="group relative bg-[#00213a] rounded-3xl p-8 overflow-hidden hover:shadow-2xl hover:-translate-y-1 transition-all duration-300">
                <div className="absolute top-0 right-0 w-24 h-24 bg-[#fdbb2e]/20 rounded-bl-full" />
                <div className="absolute bottom-0 left-0 w-16 h-16 bg-white/5 rounded-tr-full" />
                <div className="relative">
                  <div className="text-3xl mb-4 text-white" aria-hidden="true">🎓</div>
                  <h3 className="text-xl font-black text-white mb-2">Admissions</h3>
                  <p className="text-white/70 text-sm font-medium leading-relaxed mb-5">
                    Enrollment open for 3K, Pre‑K, Kindergarten &amp; all grades.
                  </p>
                  <span className="inline-flex items-center gap-1.5 text-[#fdbb2e] font-black text-sm group-hover:gap-3 transition-all duration-200">
                    Apply Now <ArrowRightIcon />
                  </span>
                </div>
              </a>

              {/* Academic Programs */}
              <a
                href="/dual_language_programs"
                aria-label="Explore Academic Programs — Dual Language, Arts, and STEM"
                className="group relative bg-[#fdbb2e] rounded-3xl p-8 overflow-hidden hover:shadow-2xl hover:-translate-y-1 transition-all duration-300"
              >
                <div className="absolute top-0 right-0 w-24 h-24 bg-[#00213a]/10 rounded-bl-full" />
                <div className="relative">
                  <div className="text-3xl mb-4" aria-hidden="true">📚</div>
                  <h3 className="text-xl font-black text-[#00213a] mb-2">Academic Programs</h3>
                  <p className="text-[#00213a]/70 text-sm font-medium leading-relaxed mb-5">
                    Arts, STEM, Dual Language &amp; more — pathways built for every learner.
                  </p>
                  <span className="inline-flex items-center gap-1.5 text-[#00213a] font-black text-sm group-hover:gap-3 transition-all duration-200" aria-hidden="true">
                    Explore <ArrowRightIcon />
                  </span>
                </div>
              </a>

              {/* Book a Tour */}
              <a
                href="#visit"
                aria-label="Schedule a tour of PS 96"
                className="group relative bg-[#00213a] rounded-3xl p-8 overflow-hidden hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 border-2 border-[#fdbb2e]/30 hover:border-[#fdbb2e]"
              >
                <div className="absolute -bottom-6 -right-6 w-24 h-24 bg-[#fdbb2e]/15 rounded-full" />
                <div className="relative">
                  <div className="text-3xl mb-4 text-white" aria-hidden="true">🏫</div>
                  <h3 className="text-xl font-black text-white mb-2">Book a Tour</h3>
                  <p className="text-white/70 text-sm font-medium leading-relaxed mb-5">
                    Come see our classrooms, hallways &amp; community in person.
                  </p>
                  <span className="inline-flex items-center gap-1.5 text-[#fdbb2e] font-black text-sm group-hover:gap-3 transition-all duration-200" aria-hidden="true">
                    Schedule <ArrowRightIcon />
                  </span>
                </div>
              </a>

              {/* For Families */}
              <div className="group relative bg-gray-50 rounded-3xl p-8 border-2 border-gray-200 hover:border-[#fdbb2e] hover:shadow-xl hover:-translate-y-1 transition-all duration-300 overflow-hidden">
                <div className="absolute top-0 right-0 w-24 h-24 bg-[#fdbb2e]/10 rounded-bl-full group-hover:bg-[#fdbb2e]/20 transition-colors duration-300" />
                <div className="relative">
                  <div className="text-3xl mb-4">👨‍👩‍👧‍👦</div>
                  <h3 className="text-xl font-black text-gray-900 mb-2">For Families</h3>
                  <ul className="space-y-2.5 mt-4">
                    {[
                      { label: 'Parent Portal', href: schoolData.quickLinks.parentPortal, external: true },
                      { label: 'Parent Handbook', href: '/parent-handbook' },
                      { label: 'School Calendar', href: schoolData.quickLinks.calendar },
                      { label: 'After-School Programs', href: '/after-school-programs' },
                      { label: 'School Lunch Menu', href: schoolData.quickLinks.lunchMenu, external: true },
                    ].map((item) => (
                      <li key={item.label}>
                        <a
                          href={item.href}
                          target={item.external ? '_blank' : undefined}
                          rel={item.external ? 'noopener noreferrer' : undefined}
                          className="flex items-center gap-2 text-sm font-semibold text-[#00213a] hover:text-[#fdbb2e] transition-colors duration-150"
                        >
                          <ArrowRightIcon /> {item.label}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

            </div>
          </div>
        </section>

        {/* ── ABOUT ────────────────────────────────────────────────────────── */}
        <section id="about" className="py-24 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid lg:grid-cols-3 gap-6">
              <div className="lg:col-span-2 lg:row-span-2 bg-[#00213a] rounded-3xl p-10 text-white relative overflow-hidden shadow-xl">
                <div className="relative z-10">
                  <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full mb-6 border border-white/30">
                    <span className="text-sm font-bold">About Us</span>
                  </div>
                  <h2 className="text-4xl font-black mb-6 leading-tight">
                    A Legacy of<br />Excellence in<br />East Harlem
                  </h2>
                  <p className="text-lg text-white mb-6 leading-relaxed max-w-xl font-medium">
                    Named after Joseph C. Lanzetta, PS 96 stands as a beacon of innovative education. We combine rigorous academics with a strong emphasis on the arts, collaborative learning, and technology integration.
                  </p>
                  <p className="text-base text-white/90 leading-relaxed max-w-xl mb-6">
                    Every student deserves access to world-class education that prepares them for success in the 21st century. Through our dual language programs, arts partnerships, and community collaborations, we create an environment where all learners thrive.
                  </p>
                  <div className="inline-flex items-center gap-3 bg-white/25 backdrop-blur-sm px-5 py-3 rounded-full border border-white/40 shadow-lg">
                    <div>
                      <div className="text-xs text-white/80 font-medium">Principal</div>
                      <div className="font-bold">{schoolData.principal}</div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="group bg-white rounded-3xl p-8 border-2 border-gray-200 hover:border-[#00213a] hover:shadow-xl transition-all duration-300">
                <div className="w-14 h-14 bg-[#00213a]/10 rounded-2xl flex items-center justify-center mb-4 text-[#00213a] group-hover:scale-110 transition-transform duration-300">
                  <BookIcon />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Our Mission</h3>
                <p className="text-gray-700 text-sm leading-relaxed font-medium">
                  At PS 96 we believe that all students have the ability to achieve high academic success. We will settle for nothing less than greatness for each and every student.
                </p>
              </div>

              <div className="bg-[#fdbb2e] rounded-3xl p-8 text-gray-900 shadow-xl hover:shadow-2xl transition-shadow duration-300">
                <div className="w-14 h-14 bg-white/30 backdrop-blur-sm rounded-2xl flex items-center justify-center mb-4">
                  <SparklesIcon />
                </div>
                <h3 className="text-xl font-black mb-4">Core Values</h3>
                <ul className="space-y-3 text-sm font-semibold">
                  {['Excellence', 'Creativity', 'Community'].map((v) => (
                    <li key={v} className="flex items-center gap-3">
                      <div className="w-2 h-2 bg-gray-900 rounded-full" />
                      {v}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* ── PROGRAMS ─────────────────────────────────────────────────────── */}
        <section id="programs" className="py-24 bg-white relative overflow-hidden">
          <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <div className="inline-flex items-center gap-2 bg-[#00213a]/10 text-[#00213a] px-4 py-2 rounded-full mb-4 font-bold text-sm">
                Our Programs
              </div>
              <h2 className="text-5xl font-black text-gray-900 mb-4">
                Signature <span className="text-[#00213a]">Programs</span>
              </h2>
              <p className="text-xl text-gray-700 font-medium">Pathways designed for every learner</p>
            </div>

            <div className="grid md:grid-cols-2 gap-8">
              <div className="group relative bg-white rounded-3xl overflow-hidden border-2 border-gray-200 hover:border-[#00213a] transition-all duration-300 hover:shadow-2xl hover:-translate-y-1">
                <div className="absolute top-0 right-0 w-40 h-40 bg-gradient-to-bl from-[#00213a]/10 to-transparent rounded-bl-[120px] group-hover:from-[#00213a]/20 transition-colors duration-300" />
                <div className="relative p-8 sm:p-10">
                  <div className="w-16 h-16 bg-gradient-to-br from-[#00213a] via-[#003a5d] to-[#00213a] rounded-2xl flex items-center justify-center mb-6 shadow-lg text-white group-hover:scale-110 transition-transform duration-300">
                    <GlobeIcon />
                  </div>
                  <h3 className="text-2xl font-black text-gray-900 mb-4">Dual Language Programs</h3>
                  <p className="text-gray-700 leading-relaxed mb-6 font-medium">
                    Specialized programs for English Language Learners, supporting bilingual development and cultural pride while ensuring academic success.
                  </p>
                  <a
                    href="/dual_language_programs"
                    aria-label="Learn more about Dual Language Programs"
                    className="inline-flex items-center gap-2 text-[#00213a] font-bold group-hover:gap-3 transition-all duration-200"
                  >
                    <span aria-hidden="true">Learn More</span>
                    <ArrowRightIcon />
                  </a>
                </div>
              </div>

              <div className="group relative bg-white rounded-3xl overflow-hidden border-2 border-gray-200 hover:border-[#fdbb2e] transition-all duration-300 hover:shadow-2xl hover:-translate-y-1">
                <div className="absolute top-0 right-0 w-40 h-40 bg-gradient-to-bl from-[#fdbb2e]/10 to-transparent rounded-bl-[120px] group-hover:from-[#fdbb2e]/20 transition-colors duration-300" />
                <div className="relative p-8 sm:p-10">
                  <div className="w-16 h-16 bg-gradient-to-br from-[#fdbb2e] via-[#fdc951] to-[#fdd874] rounded-2xl flex items-center justify-center mb-6 shadow-lg text-gray-900 group-hover:scale-110 transition-transform duration-300">
                    <SparklesIcon />
                  </div>
                  <h3 className="text-2xl font-black text-gray-900 mb-4">Arts &amp; Technology</h3>
                  <p className="text-gray-700 leading-relaxed mb-6 font-medium">
                    Integrated approach combining visual arts, music, and cutting-edge technology to prepare students for creative careers and innovative thinking.
                  </p>
                  <a href="#programs" className="inline-flex items-center gap-2 text-[#7a5300] font-bold group-hover:gap-3 transition-all duration-200">
                    Explore Programs <ArrowRightIcon />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ── PS 96 IN NUMBERS ─────────────────────────────────────────────── */}
        <section className="py-20 bg-[#00213a] relative overflow-hidden">
          <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-black text-white">
                PS 96 <span className="text-[#fdbb2e]">in Numbers</span>
              </h2>
            </div>
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
              {[
                { n: '306', l: 'Students', icon: '🎓', amber: true },
                { n: '30+', l: 'Dedicated Teachers', icon: '📚', amber: false },
                { n: '4', l: 'Foreign Languages', icon: '🌍', amber: true },
                { n: '3', l: 'After-School Programs', icon: '⭐', amber: false },
              ].map((s, i) => (
                <div
                  key={i}
                  className={`${s.amber ? 'bg-[#fdbb2e] text-[#00213a]' : 'bg-white/10 border border-white/20 text-white'} rounded-3xl p-7 text-center hover:scale-105 transition-transform duration-200 shadow-lg`}
                >
                  <div className="text-3xl mb-3">{s.icon}</div>
                  <div className="text-5xl font-black leading-none mb-2">{s.n}</div>
                  <div className="text-xs font-black uppercase tracking-widest opacity-80">{s.l}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ── PARENT TESTIMONIALS ──────────────────────────────────────────── */}
        <section className="py-24 bg-white" aria-labelledby="testimonials-heading">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-14">
              <div className="inline-flex items-center gap-2 bg-[#fdbb2e]/20 text-[#7a5300] px-4 py-2 rounded-full mb-4 font-bold text-sm">
                Our Community Speaks
              </div>
              <h2 id="testimonials-heading" className="text-5xl font-black text-gray-900 mb-4">
                Hear from Our <span className="text-[#00213a]">Parents</span>
              </h2>
              <p className="text-xl text-gray-600 font-medium">What PS 96 families are saying</p>
            </div>
            <div className="grid sm:grid-cols-2 gap-6">
              {[
                { name: 'Cristina', grade: '3K Parent', quote: 'My child has a lot of fun while learning at school. The school culture is wonderful and the care teachers show toward students is evident — staff demonstrate a genuine love for helping children reach their fullest potential. The school is warm and welcoming.' },
                { name: 'Tashona S.', grade: '5th Grade Parent', quote: 'My child loves learning and enjoys his teachers very much. The staff are always willing to lend a helping hand. Communication is one of the school\'s greatest strengths.' },
                { name: 'Raven J.', grade: 'Kindergarten Parent', quote: 'My child enjoys school performances and activities. PS 96 is a great community school that is very resourceful for families. Everyone here is available and willing to help.' },
                { name: 'Nadeen M.', grade: '3rd Grade Parent', quote: 'My child especially enjoys the teachers at school. PS 96 is a caring community where teachers are invested in students\' success. I also value the strong relationships I\'ve built with my son\'s teachers.' },
              ].map((t, i) => (
                <figure
                  key={i}
                  className="group bg-gray-50 rounded-3xl p-8 border-2 border-gray-200 hover:border-[#00213a] hover:shadow-xl hover:-translate-y-0.5 transition-all duration-300 flex flex-col"
                >
                  <svg className="w-8 h-8 text-[#fdbb2e] mb-5 flex-shrink-0" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
                  </svg>
                  <blockquote className="text-gray-700 text-base leading-relaxed font-medium flex-1 mb-6">
                    {t.quote}
                  </blockquote>
                  <figcaption className="border-t border-gray-200 pt-5 mt-auto">
                    <div className="font-black text-gray-900">{t.name}</div>
                    <div className="text-sm font-semibold text-[#00213a]/70 mt-0.5">{t.grade}</div>
                  </figcaption>
                </figure>
              ))}
            </div>
          </div>
        </section>

        {/* ── COMMUNITY PARTNERS ───────────────────────────────────────────── */}
        <section className="py-24 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-black text-gray-900 mb-4">
                Community <span className="text-[#7a5300]">Partners</span>
              </h2>
              <p className="text-lg text-gray-600">Collaborating for student success</p>
            </div>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {[
                { name: 'Global Kids, Inc.', url: '/global_kids_inc', navy: true },
                { name: 'Cool Culture', url: '/cool_culture', navy: false },
                { name: 'Union Settlement', url: '/union_settlement', navy: false },
              ].map((p, idx) => (
                <a
                  key={idx}
                  href={p.url}
                  aria-label={`Learn more about our community partner ${p.name}`}
                  className={`group relative rounded-2xl p-6 border-2 transition-all duration-200 overflow-hidden hover:shadow-xl hover:-translate-y-0.5 ${p.navy ? 'bg-white border-gray-200 hover:border-[#00213a]' : 'bg-white border-gray-200 hover:border-[#fdbb2e]'}`}
                >
                  <div className={`absolute top-0 right-0 w-20 h-20 rounded-bl-[60px] opacity-0 group-hover:opacity-100 transition-opacity duration-200 ${p.navy ? 'bg-[#00213a]/10' : 'bg-[#fdbb2e]/20'}`} aria-hidden="true" />
                  <h3 className="relative font-bold text-gray-900 text-lg">{p.name}</h3>
                  <span
                    className={`relative inline-flex items-center gap-1 mt-3 text-xs font-bold opacity-0 group-hover:opacity-100 transition-all duration-200 ${p.navy ? 'text-[#00213a]' : 'text-[#7a5300]'}`}
                    aria-hidden="true"
                  >
                    Learn more <ArrowRightIcon />
                  </span>
                </a>
              ))}
            </div>
          </div>
        </section>

        {/* ── NEWS & EVENTS ────────────────────────────────────────────────── */}
        <section className="py-24 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid lg:grid-cols-2 gap-12">
              <div id="news">
                <div className="flex items-center justify-between mb-8">
                  <h2 className="text-3xl font-black text-gray-900">Latest News</h2>
                  <a
                    href="/announcements"
                    aria-label="View all announcements"
                    className="text-[#00213a] font-bold text-sm hover:underline"
                  >
                    View All
                  </a>
                </div>
                <a
                  href="/announcements"
                  className="group block bg-gray-50 rounded-2xl overflow-hidden border border-gray-200 hover:border-[#fdbb2e] hover:shadow-md transition-all duration-200 mb-4"
                >
                  <img
                    src="/assets/images/flyers/family-movie-night-english.jpg"
                    alt="Family Movie Night flyer: Hotel Transylvania, October 23 at 3:00 PM, $5 per family, cash only, includes the movie, popcorn, a drink and candy for everyone. Students must be accompanied by an adult."
                    className="w-full h-auto border-b border-gray-200"
                  />
                  <div className="p-6">
                    <div className="text-sm text-[#00213a] font-bold mb-2">Friday, October 23 · 3:00 PM</div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-[#00213a]">
                      <span aria-hidden="true">🎬</span> Family Movie Night at PS 96
                    </h3>
                    <p className="text-gray-600 text-sm">
                      Join us for Hotel Transylvania! $5 per family (cash only) includes the movie, popcorn, a drink, and candy for everyone. Students must be accompanied by an adult.
                    </p>
                    <span className="inline-flex items-center gap-1.5 mt-4 text-sm font-black text-[#00213a] group-hover:gap-3 transition-all">
                      See the flyer <ArrowRightIcon />
                    </span>
                  </div>
                </a>
                <a
                  href="/announcements"
                  className="group block bg-gray-50 rounded-2xl overflow-hidden border border-gray-200 hover:border-[#fdbb2e] hover:shadow-md transition-all duration-200 mb-4"
                >
                  <img
                    src="/assets/images/flyers/classbank-october-2026-student.jpg"
                    alt=""
                    className="w-full h-auto border-b border-gray-200"
                  />
                  <div className="p-6">
                    <div className="text-sm text-[#00213a] font-bold mb-2">October 8, 2026</div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-[#00213a]">
                      <span aria-hidden="true">🏦</span> ClassBank in October: How Students Earn
                    </h3>
                    <p className="text-gray-600 text-sm">
                      Lions earn classroom dollars for attendance, uniform, and great behavior — then shop in our school-wide store while building real financial skills. Shop Oct 5–14 and Oct 19–28!
                    </p>
                    <span className="inline-flex items-center gap-1.5 mt-4 text-sm font-black text-[#00213a] group-hover:gap-3 transition-all">
                      See how to earn <ArrowRightIcon />
                    </span>
                  </div>
                </a>
                <a
                  href="/announcements"
                  className="group block bg-gray-50 rounded-2xl p-6 border border-gray-200 hover:border-[#fdbb2e] hover:shadow-md transition-all duration-200"
                >
                  <div className="text-sm text-[#00213a] font-bold mb-2">October 8, 2025</div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-[#00213a]">
                    🎬 Celebrity Substitute
                  </h3>
                  <p className="text-gray-600 text-sm">
                    A special guest stepped in as a celebrity substitute at PS 96 — watch the full reveal.
                  </p>
                  <span className="inline-flex items-center gap-1.5 mt-4 text-sm font-black text-[#00213a] group-hover:gap-3 transition-all">
                    Read on Announcements <ArrowRightIcon />
                  </span>
                </a>
              </div>
              <div id="events">
                <div className="flex items-center justify-between mb-8">
                  <h2 className="text-3xl font-black text-gray-900">Upcoming Events</h2>
                  <a href={schoolData.quickLinks.calendar} className="text-[#00213a] font-bold text-sm hover:underline">
                    View Calendar
                  </a>
                </div>
                <ul className="space-y-3">
                  {upcomingEvents.map((evt, i) => (
                    <li key={i}>
                      <a
                        href={evt.href}
                        className="group flex items-center gap-4 bg-gray-50 rounded-2xl p-4 border-2 border-gray-200 hover:border-[#fdbb2e] hover:shadow-md transition-all duration-200"
                      >
                        <div className={`flex-shrink-0 w-16 rounded-xl py-2 text-center ${evt.closed ? 'bg-[#fdbb2e] text-[#00213a]' : 'bg-[#00213a] text-white'}`}>
                          <div className="text-[10px] font-black uppercase tracking-widest opacity-80">{evt.month}</div>
                          <div className="text-2xl font-black leading-none">{evt.day}</div>
                        </div>
                        <div className="min-w-0">
                          <h3 className="font-bold text-gray-900 leading-snug">{evt.title}</h3>
                          <p className="text-sm font-semibold text-[#00213a]/70 mt-0.5">
                            {evt.weekday}{evt.time ? ` · ${evt.time}` : ''}
                          </p>
                        </div>
                      </a>
                    </li>
                  ))}
                </ul>
                <a
                  href={schoolData.quickLinks.calendar}
                  className="inline-flex items-center gap-1.5 mt-6 text-sm font-black text-[#00213a] hover:gap-3 transition-all duration-200"
                >
                  See full calendar <ArrowRightIcon />
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* ── FOLLOW US ────────────────────────────────────────────────────── */}
        {/* Instagram grid (synced daily by scripts/sync-instagram.mjs). Until the first
            sync has run, the simple follow banner below is shown instead. */}
        {instagramFeed.posts.length >= 3 ? (
          <InstagramFeed feed={instagramFeed} facebookUrl={schoolData.socialLinks.facebook} />
        ) : (
        <section className="py-16 bg-[#fdbb2e]">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-8">
              <div>
                <p className="text-xs font-black uppercase tracking-widest text-[#00213a] mb-1">Stay Connected</p>
                <h2 className="text-3xl font-black text-[#00213a]">Follow Our Story</h2>
                <p className="text-[#00213a]/80 font-medium mt-2 max-w-sm">
                  See daily moments from our classrooms, hallways, and community.
                </p>
              </div>
              <div className="flex flex-col gap-3 items-center sm:items-end">
                <a
                  href={schoolData.socialLinks.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-3 px-7 py-4 bg-[#00213a] text-white font-black rounded-2xl shadow-lg hover:shadow-xl hover:-translate-y-0.5 transition-all duration-200 text-base"
                >
                  <InstagramIcon />
                  @ps96act on Instagram
                </a>
                <a
                  href={schoolData.socialLinks.facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm font-bold text-[#00213a]/70 hover:text-[#00213a] transition-colors duration-150"
                >
                  Also on Facebook → PS96Lions
                </a>
              </div>
            </div>
          </div>
        </section>
        )}

        {/* ── PHOTO COLLAGE ────────────────────────────────────────────────── */}
        <section aria-label="School photo gallery" className="bg-[#00213a]">
          <div className="py-10 text-center">
            <p className="text-xs font-black uppercase tracking-[0.2em] text-[#fdbb2e] mb-1">Our School</p>
            <h2 className="text-3xl font-black text-white">Life at PS 96</h2>
          </div>

          <div className="overflow-hidden mb-2" aria-hidden="true">
            <div
              className="flex gap-2"
              style={{ animation: 'marquee 35s linear infinite', width: 'max-content' }}
            >
              {[
                '1000013076.jpg','IMG_0166.jpeg','IMG_1012.JPEG','20260615_125858.JPG','IMG_1847.jpeg','IMG_1871.jpeg',
                '3619__1_.jpg','IMG_3204.jpeg','1000016232.jpeg','IMG_3230.jpeg','IMG_3615.JPEG','1000013101.jpg',
                '1000013076.jpg','IMG_0166.jpeg','IMG_1012.JPEG','20260615_125858.JPG','IMG_1847.jpeg','IMG_1871.jpeg',
                '3619__1_.jpg','IMG_3204.jpeg','1000016232.jpeg','IMG_3230.jpeg','IMG_3615.JPEG','1000013101.jpg',
              ].map((file, i) => (
                <img key={i} src={`/assets/images/homepage/${file}`} alt="" className="h-56 w-auto object-cover rounded-lg flex-shrink-0" loading="lazy" />
              ))}
            </div>
          </div>

          <div className="overflow-hidden pb-10" aria-hidden="true">
            <div
              className="flex gap-2"
              style={{ animation: 'marquee 40s linear infinite reverse', width: 'max-content' }}
            >
              {[
                'IMG_3615.JPEG','IMG_3230.jpeg','1000016239.jpeg','IMG_3204.jpeg','3619__1_.jpg','1000013101.jpg',
                'IMG_1871.jpeg','IMG_1847.jpeg','1000016232.jpeg','IMG_1012.JPEG','IMG_0166.jpeg','1000013076.jpg',
                'IMG_3615.JPEG','IMG_3230.jpeg','1000016239.jpeg','IMG_3204.jpeg','3619__1_.jpg','1000013101.jpg',
                'IMG_1871.jpeg','IMG_1847.jpeg','1000016232.jpeg','IMG_1012.JPEG','IMG_0166.jpeg','1000013076.jpg',
              ].map((file, i) => (
                <img key={i} src={`/assets/images/homepage/${file}`} alt="" className="h-48 w-auto object-cover rounded-lg flex-shrink-0" loading="lazy" />
              ))}
            </div>
          </div>
        </section>

        {/* ── CTA BANNER ───────────────────────────────────────────────────── */}
        <section id="visit" className="relative py-32 overflow-hidden bg-[#00213a]">
          <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <div className="inline-flex items-center gap-2 bg-[#fdbb2e] px-4 py-2 rounded-full mb-6 text-[#00213a] font-black text-sm">
              🦁 Join Our Community
            </div>
            <h2 className="text-5xl md:text-6xl font-black text-white mb-6 leading-tight">
              You Belong<br />
              at <span className="text-[#fdbb2e]">PS 96</span>
            </h2>
            <p className="text-xl text-gray-300 mb-12 max-w-2xl mx-auto">
              Come see what makes our Lions community special. Schedule a tour and discover the PS 96 difference.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a href="#contact" className="inline-flex items-center gap-2 px-10 py-5 text-lg font-black text-[#00213a] bg-[#fdbb2e] hover:bg-[#ffd04e] rounded-2xl shadow-2xl hover:shadow-[#fdbb2e]/30 transition-all duration-200">
                Schedule a Visit <ArrowRightIcon />
              </a>
              <a
                href={schoolData.quickLinks.nycdoe}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-10 py-5 text-lg font-black text-white bg-white/10 hover:bg-white/20 backdrop-blur-sm border-2 border-white/30 rounded-2xl transition-all duration-200"
              >
                Enroll Now
              </a>
            </div>
          </div>
        </section>


      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
